import React, { ReactElement, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "../button";
import { Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay } from "../modal";
import ImageUploadDropPane from "./ImageUploadDropPane";
import { IImageUploadProps } from "./misc";

interface IImageUploadModalChildrenProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

interface IImageUploadModalProps extends IImageUploadProps {
  uploadButtonText?: string;
  children?: (args: IImageUploadModalChildrenProps) => ReactElement;
}

export default function ImageUploadModal({
  uploadButtonText,
  onSave,
  imageData,
  options,
  children,
}: IImageUploadModalProps) {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      {children && children({ setOpen })}

      {!children && (
        <Button variant="primary" fullWidth={true} onClick={() => setOpen(true)}>
          {uploadButtonText ? uploadButtonText : <FormattedMessage defaultMessage="Upload" id="p4N05H" />}
        </Button>
      )}

      <Modal isOpen={isOpen} onClose={() => setOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader bg="#eeeeee">
            <FormattedMessage defaultMessage="Upload Image" id="MntrZe" />
          </ModalHeader>
          <ModalBody bg="#eeeeee">
            <ImageUploadDropPane
              onSave={(imageData) => {
                onSave(imageData);
                setOpen(false);
              }}
              imageData={imageData}
              options={options}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
